import { useLayoutEffect} from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Layout from './routes/layout/layout.component';
import Sandbox from './routes/sandbox/sandbox.component';
import SignIn from './routes/sign-in/sign-in.component';
import NotFound from './routes/not-found/not-found.component';
import PublicRoute from './components/public-route/public-route';
import PrivateRoute from './components/private-route/private-route.component';
import Account from './routes/account/account.component';
import ForgotPassword from './routes/forgot-password/forgot-password.component';
import RoundtableRoute from './components/roundtable-route/roundtable-route';
import CustomSandboxRoute from './components/custom-sandbox-route/custom-sandbox-route.component';
import Showcase from './routes/showcase/showcase.component';
import SignUp from './routes/sign-up/sign-up.component';
import SandboxLink from './routes/sandbox-link/sandbox-link.component';
import Demo from './routes/demo/demo.component';
import TermsOfService from './routes/terms-of-service/terms-of-service.component';
import PrivacyPolicy from './routes/privacy-policy/privacy-policy.component';
import Dashboard from './routes/dashboard/dashboard.component';
import { useUserAuth } from './contexts/user.context';
import KeystrokeHistory from './routes/keystroke-history/keystroke-history.component';
import KeystrokeHistoryInternal from './routes/keystroke-history-internal/keystrok-history-internal.component';
import KeystrokePublic from './routes/keystroke-public/keystroke-public.component';
// import DemoTemp from './routes/demo-temp/demo-temp.component';

const App = () => {

  const location = useLocation();
  const { currentUser } = useUserAuth();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to={currentUser ? "/dashboard" : "/sign-up"} />} />
      <Route path='/' element={<Layout />}>
        {/* <Route index element={<RoundtableRoute><Dashboard /></RoundtableRoute>} /> */}
        <Route
          path='/sign-in'
          element={<PublicRoute><SignIn /></PublicRoute>}
        />
        <Route
          path='/forgot-password'
          element={<PublicRoute><ForgotPassword /></PublicRoute>}
        />
        <Route
          path='/sign-up'
          element={<PublicRoute><SignUp /></PublicRoute>}
        />
        <Route
          path='/account'
          element={<PrivateRoute><Account /></PrivateRoute>}
        />
        <Route
          path="/simulator-link/:surveyId"
          element={<CustomSandboxRoute><SandboxLink /></CustomSandboxRoute>}
        />
        <Route
          path="/simulator-link"
          element={<CustomSandboxRoute><SandboxLink /></CustomSandboxRoute>}
        />
        <Route
          path="/simulator/:surveyId"
          element={<CustomSandboxRoute><Sandbox /></CustomSandboxRoute>}
        />
        <Route
          path="/simulator"
          element={<CustomSandboxRoute><Sandbox /></CustomSandboxRoute>}
        />
        <Route
          path='/dashboard'
          element={<PrivateRoute><Dashboard /></PrivateRoute>}
        />
        <Route
          path='/keystroke-history/:callId'
          element={<PrivateRoute><KeystrokeHistory /></PrivateRoute>}
        />
        <Route
          path='/keystroke-history/:callId/:questionId'
          element={<PrivateRoute><KeystrokeHistory /></PrivateRoute>}
        />
        <Route
          path='/keystroke-history-internal'
          element={<PrivateRoute><KeystrokeHistoryInternal /></PrivateRoute>}
        />
        <Route
          path='/demo'
          element={<PrivateRoute><Demo /></PrivateRoute>}
        />
        <Route
          path='/showcase'
          element={<RoundtableRoute><Showcase /></RoundtableRoute>}
        />
        <Route
          path='/terms'
          element={<RoundtableRoute><TermsOfService /></RoundtableRoute>}
        />
        <Route
          path='/privacy'
          element={<RoundtableRoute><PrivacyPolicy /></RoundtableRoute>}
        />
        <Route
          path='/keystrokes'
          element={<RoundtableRoute><KeystrokePublic /></RoundtableRoute>}
        />
        <Route
          path='/keystrokes/:questionId'
          element={<RoundtableRoute><KeystrokePublic /></RoundtableRoute>}
        />
        <Route path='*' element={<RoundtableRoute><NotFound /></RoundtableRoute>} />
      </Route>
    </Routes>
  )
}

export default App;